import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsappFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href="https://wa.me/5542984285953?text=Ol%C3%A1%2C%20gostaria%20de%20personalizar%20um%20presente%20na%20Eterniza%20Im%C3%A3s"
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg wa-pulse"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle size={24} />
    </a>
  );
}
